/**
 * "New contact messages" count for the sidebar badge.
 *
 * The Contact messages page fires CONTACT_CHANGED_EVENT after it marks a message or
 * deletes one, so the badge follows at once instead of waiting for the next poll.
 */

import { useEffect, useState } from 'react';
import { AdminApiClient } from '../../api';

export const CONTACT_CHANGED_EVENT = 'vloud:contact-messages-changed';
const POLL_MS = 60_000;

/** `null` while unknown (no session, no permission, or an older server without the route). */
export function useNewContactCount(token: string | null): number | null {
  const [count, setCount] = useState<number | null>(null);

  useEffect(() => {
    if (!token) {
      setCount(null);
      return;
    }
    let alive = true;
    const api = new AdminApiClient({ baseUrl: '', getToken: () => token });
    const load = (): void => {
      api.contactMessagesSummary()
        .then((r) => { if (alive) setCount(r.new_count); })
        .catch(() => { if (alive) setCount(null); });
    };
    load();
    const timer = setInterval(load, POLL_MS);
    window.addEventListener(CONTACT_CHANGED_EVENT, load);
    return () => {
      alive = false;
      clearInterval(timer);
      window.removeEventListener(CONTACT_CHANGED_EVENT, load);
    };
  }, [token]);

  return count;
}
